export default function Social({ skills }) {
  if (!skills) return null;

  return (
    <div
      style={{
        backgroundColor: 'var(--card-background, #fff)',
        borderRadius: 16,
        padding: '20px 24px',
        border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
        boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
      }}
    >
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--heading-primary, #111827)', marginBottom: 12 }}>
            Skills
          </div>

          <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(3, 1fr)' }}>
            {skills.skills?.map((item, index) => (
              <div
                key={index}
                style={{
                  padding: 12,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <span
                  style={{
                    backgroundColor: 'var(--status-neutral-bg, #F3F4F6)',
                    padding: 12,
                    borderRadius: 8,
                    fontSize: 13,
                    color: 'var(--text-primary, #111827)',
                    fontWeight: 500,
                  }}
                >
                  {item}
                </span>
              </div>
            ))}
          </div>
    </div>
  );
}
